import { Link, useLocation } from "react-router-dom";

export default function Logo({ dark = false, to = "/" }) {
  const { pathname } = useLocation();
  const onHomeTop = (e) => {
    if (to === "/" && pathname === "/") {
      e.preventDefault();
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  };
  return (
    <Link to={to} onClick={onHomeTop} className="group flex items-center" data-testid="brand-logo" aria-label="ShipAny home">
      <span className="rounded-xl bg-white px-3 py-2 shadow-sm ring-1 ring-slate-200/60 transition-transform duration-300 group-hover:scale-[1.03]">
        <img src="/logo.png" alt="ShipAny — Ship Anywhere. Ship Smarter." className="h-8 w-auto object-contain" />
      </span>
    </Link>
  );
}
